export const promoteConsoleErrors = () => {
	const id = 'app-error';
	const clearAppError = () => document.getElementById(id)?.remove();
	const excludes = [
		'[webpack-dev-server]',
		'React state update on an unmounted component', // switching modern assessment left nav items: https://github.com/microsoft/fluentui/issues/30885
		'`getDerivedStateFromProps` arguments have a consistent shape', // initial load of Configuration page,

		// 'https://stackoverflow.com/a/75124510',
		'Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.',
		'Report Configuration not found', // assessment reporting report not yet available
	];
	const original = window.console.error;
	window.console.error = (...data: unknown[]) => {
		original.apply(console, data);
		const consoleString = data[0] ?? data;

		for (const exclude of excludes) {
			if (typeof consoleString === 'string' && consoleString.includes(exclude)) {
				return;
			}
		}

		clearAppError();
		const errorDiv = document.createElement('div');
		errorDiv.id = id;
		errorDiv.style.cssText = `
			position: fixed;
			bottom: 0;
			box-sizing: border-box;
			width: 100vw;
			height: 33vh;
			padding: 0.5rem 2rem;
			line-height: 1.2;
			white-space: pre-wrap;
			overflow: auto;
			background-color: rgba(0, 0, 0, 0.75);
			color: rgb(252, 207, 207);
			font-family: Menlo, Consolas, monospace;
			::-webkit-scrollbar {
				display: none;
			}
			-ms-overflow-style: none;
			scrollbar-width: none;
			word-wrap: break-word;
			overflow-wrap: break-word;
			z-index: 100;
		`;

		const closeButton = document.createElement('button');
		closeButton.textContent = 'x';
		closeButton.style.cssText = `
			color: rgb(255, 255, 255);
			line-height: 1rem;
			padding: 1rem;
			cursor: pointer;
			position: absolute;
			right: 0px;
			top: 0px;
			background-color: transparent;
			border: none;
		`;
		closeButton.onclick = clearAppError;

		const errorTitle = document.createElement('h2');
		errorTitle.textContent = 'Console error (CTRL+SHIFT+I / F12)';
		errorTitle.style.cssText = `
			color: rgb(232, 59, 70);
			margin-bottom: 0.5rem;
		`;

		// eslint-disable-next-line @typescript-eslint/no-base-to-string
		errorDiv.append(closeButton, errorTitle, `${consoleString}\n\n${Error().stack.replaceAll('Error\n', '')}`);
		document.body.appendChild(errorDiv);

		window.setTimeout(clearAppError, 7_000);
	};
};
